module.exports = "/fonts/vendor/element-ui/lib/theme-default/element-icons.ttf?b02bdc1b846fd65473922f5f62832108";